import { firebaseClient } from 'firebaseClient';
import { getAccount } from 'utils/sessionHelper';

export const getGamificationRequirements = async (
  currentLevel: string,
  db: firebaseClient.firestore.Firestore
) => {
  const requirementsDoc = await db
    .collection('levelRequirements')
    .doc(currentLevel)
    .get();
  const data = requirementsDoc.data();
  return data;
};

export const getUserLevelProgress = async (
  userSession: any,
  db: firebaseClient.firestore.Firestore
) => {
  const userProgressDoc = await db
    .collection('users')
    .doc(userSession?.id)
    .collection('levelProgress')
    .doc(userSession?.idLinkedin)
    .get();
  const data = userProgressDoc.data();

  return data;
};

export const getUserGamificationState = async (
  userSession: any,
  db: firebaseClient.firestore.Firestore
) => {
  const userGamificationStateDoc = await db
    .collection('users')
    .doc(userSession?.id)
    .collection('gamification')
    .doc(userSession?.idLinkedin)
    .get();
  const data = userGamificationStateDoc.data();

  return data;
};

export const getGamification = async (account: any) => {
  const db = firebaseClient.firestore();
  const levelProgress = await getUserLevelProgress(account, db);
  const userGamificationState = await getUserGamificationState(account, db);
  const requirements = await getGamificationRequirements(
    userGamificationState?.currentLevel || 'bronze',
    db
  );

  return {
    requirements,
    levelProgress,
    userGamificationState,
  };
};
